<template>
  <div class="signatoryList">
    <div class="signatoryBox">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
          <el-breadcrumb-item>签约方管理</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="authorizationMain">
        <div class="authorizationCon">
          <div class="allAuthorized selectAuthor authorTable" v-show="authorTable">
            <p class="authorSearch">
              <input class="fl ft14" type="text" placeholder="手机号码/邮箱号码" v-model="conName">
              <span @click="searchFn"></span>
              <span class="fr ft12 textAlign enter" @click="addSignatory('ruleFormEn')"><i></i>新增企业签约方</span>
              <span class="fr ft12 textAlign " @click="addSignatory('ruleForm')"><i></i>新增个人签约方</span>
            </p>
            <el-table :data="listsTables" border style="width: 100%">
              <template slot="empty">
                <img class="data-pic" src="../../../assets/images/H5/null.png" alt>
                <br>暂无数据
              </template>
              <el-table-column prop="name" label="公司名称/姓名"></el-table-column>
              <el-table-column label="手机号码/邮箱">
                <template slot-scope="scope">
                  <span v-if="scope.row.type==2"></span>
                  <span v-else>{{scope.row.mobile?scope.row.mobile:scope.row.mail?scope.row.mail:''}}</span>
                </template>
              </el-table-column>
              <el-table-column label="实名状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.really==1 ">
                    <img src="../../../assets/images/signtory/no_real_icon.png">未实名
                  </span>
                  <span v-if="scope.row.really==0 ">
                    <img src="../../../assets/images/signtory/have_real_icon.png">已实名
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.enabled==0">已禁用</span>
                  <span v-if="scope.row.enabled==1">已启用</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span v-if="scope.row.enabled==0" style="color: #DCDCDC;">禁用</span>
                  <span
                    v-if="scope.row.enabled==0"
                    @click="isStart(1,scope.row.id)"
                    style="color: #28BF15;margin-left:10px;cursor: pointer;"
                  >启用</span>
                  <span
                    v-if="scope.row.enabled==1"
                    @click="isStart(0,scope.row.id)"
                    style="color: #E88078;cursor: pointer;"
                  >禁用</span>
                  <span v-if="scope.row.enabled==1" style="color: #DCDCDC;margin-left:10px;">启用</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="fenYeBox">
              <el-pagination
                v-if="showPaginationp"
                @size-change="handleSizeChangep"
                @current-change="handleCurrentChangep"
                :current-page="currentPagep"
                :page-sizes="pageSizesp"
                :page-size="pageSizep"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalp"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popUp">
      <Dialog
        :visible="dialogVisible"
        :dialogTitle="'添加个人签署方'"
        v-on:closeDialog="closeDialog"
        :width="'360px'"
      >
        <div slot="dialog">
          <div class="addSignatoryBox">
            <div class="addSignatoryCon ft12">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="手机号/邮箱：" prop="photo">
                  <el-input type="text" v-model="ruleForm.photo"></el-input>
                  <p class="hintBox" v-if="exist">用户已经存在,不能重复添加</p>
                  <p class="hintBox" v-if="exists">不能添加自己为授权人</p>
                </el-form-item>
                <el-form-item>
                  <el-button @click="cancelFn">取消</el-button>
                  <el-button type="primary" @click="saveFn('ruleForm')" v-if="isSubmit">提交</el-button>
                  <el-button type="primary" v-if="!isSubmit">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </Dialog>
       <Dialog
        :visible="dialogVisibleEn"
        :dialogTitle="'添加企业签署方'"
        v-on:closeDialog="closeDialog"
        :width="'360px'"
      >
      
        <div slot="dialog">
          <div class="addSignatoryBox enBox">
            <div class="addSignatoryCon enSign ft12">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleFormEn"
                label-width="100px"
                class="demo-ruleForm"
              >  <div class="enTerper">
                    请输入企业名称：
                  </div>
                <el-form-item  prop="photoEn">
                  <el-input type="text" placeholder="请输入已实名的企业名称" v-model="ruleForm.photoEn"></el-input>
                  <p class="hintBox" v-if="exist">用户已经存在,不能重复添加</p>
                  <p class="hintBox" v-if="exists">不能添加自己为授权人</p>
                </el-form-item>
                <el-form-item>
                  <el-button @click="cancelFn">取消</el-button>
                  <el-button type="primary" @click="saveFn('ruleFormEn')" v-if="isSubmit">提交</el-button>
                  <el-button type="primary" v-if="!isSubmit">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="dialogStatus"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'450px'"
      >
        <div slot="dialog" class="changeStatus">
          <p>是否禁用/启用该签约方？</p>
          <p>
            <span @click="cancelFn">取消</span>
            <span @click="trueChanges(2)">确定</span>
          </p>
        </div>
      </Dialog>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import BaseApi from "@lib/baseApi.js";
import Dialog from "../../common/Dialog.vue";
import breadcrumb from "@common/Breadcrumb.vue";
import {mapGetters} from "vuex";
export default {
  data() {
    var PhotoMail = (rule, value, callback) => {
      var regP = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      var regM = /^[A-Za-z0-9\._-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!regP.test(value) && !regM.test(value)) {
        callback(new Error("您输入的格式不对"));
      }
      callback();
    };
    return {
      isSubmit: true,
      id: "",
      names: "",
      conName: "",
      //企业签约方添加
      ruleForm: {
        photo: "", //手机号,
        photoEn:""
      },
      rules: {
        photo: [
          { required: true, message: "请输入手机号/邮箱", trigger: "blur" },
          { validator: PhotoMail, trigger: "blur" }
        ],
        photoEn: [
          { required: true, message: "请输企业名称", trigger: "blur" },
        ]
      },
      listsTables: [],
      exists: false,
      dialogVisible: false,
      signContractTipData: [],
      dialogVisiblePer: false,
      dialogStatus: false,
      dialogStatuses: false,
      currentPage: 1, //默认第一页
      total: "", //总条数
      pageSizes: [10, 30, 50, 100, 150, 200],
      pageSize: 10, //默认第一页展示10条
      currentPagep: 1, //默认第一页
      totalp: "", //总条数
      pageSizesp: [10, 30, 50, 100, 150, 200],
      pageSizep: 10, //默认第一页展示10条
      authorTable: true,
      showPagination: false,
      showPaginationp: false,
      num: "",
      status: "1",
      exist: false,
      dialogVisibleEn:false,
      queryuserNameList:[]
    };
  },
  computed:{
    ...mapGetters(["getUserInfo"])
  },
  methods: {
    init() {
      var queryStr = {
        type: "",
        userInput: this.conName,
        pageNumber: this.currentPagep,
        pageSize: this.pageSizep
      };
      if (this.conName) queryStr.userInput = this.conName;
      console.log(queryStr);
      BaseApi.createRpcToken("/signatory/signatoryList", queryStr)
        .then(
          data => {
            console.log(data);
            if (data.datas != null) {
              this.listsTables = data.datas.list;
              this.totalp = data.datas.totalRow;
              if (data.datas.totalRow > 10) {
                this.showPaginationp = true;
              } else {
                this.showPaginationp = false;
              }
            }
          },
          data => {
            console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    searchFn() {
      var this_1 = this;
      this_1.init();
    },
    trueChanges() {
      var this_1 = this;
      var queryStrs = {
        handleType: "2",
        type: "2",
        id: this.id,
        status: this.num
      };
      this.isSubmit = false;
      BaseApi.createRpcToken("/signatory/modifyStatus", queryStrs, "post").then(
        data => {
          this.init();
          this.dialogStatus = false;
          this.isSubmit = true;
        },
        data => {
          console.log(data);
        }
      );
    },
    trueChange() {
      var this_1 = this;
      var queryStres = {
        handleType: "2",
        type: "1",
        id: this.id,
        status: this.num
      };
      BaseApi.createRpcToken("/signatory/modifyStatus", queryStres, "post")
        .then(
          data => {
            this.dialogStatuses = false;
            this.init1();
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    closeDialog(data) {
      console.log(data);
      this.dialogVisible = data;
        this.dialogVisibleEn = data;
      this.dialogVisiblePer = data;
      this.dialogStatus = data;
      this.dialogStatuses = data;
    },
    isStart(num, id) {
      this.num = num;
      this.id = id;
      this.dialogStatus = true;
    },
    cancelFn() {
      this.dialogVisible = false;
        this.dialogVisibleEn = false;
      this.dialogStatus = false;
      this.dialogStatuses = false;
    },
    addSignatory(formName) {
      this.status = "2";
      this.ruleForm.companyName = "";
      this.ruleForm.contactName = "";
      this.ruleForm.photo = "";
      this.ruleForm.eMail = "";
      if(formName=="ruleForm"){
      this.dialogVisible = true;
      }else{
         this.dialogVisibleEn = true;
      }
    },
    judgeUid(signatoryId) {
      for (let i = 0; i < this.listsTables.length; i++) {
        if (this.listsTables[i].id == signatoryId) {
          return false;
        }
      }
      return true;
    },
    saveFn(formName) {
      this.$refs[formName].validate(valid => {
        console.log(valid,formName);
        if (valid) {
          if (formName == "ruleForm") {
            if (localStorage.getItem("userName") == this.ruleForm.photo) {
              this.$message.error("不能添加自己为授权人");
              return;
            }
            this.isSubmit = false;
            var queryStr = {
              contactName: this.ruleForm.companyName,
              mobile: "",
              mail: "",
              type: "1"
            };
            var regP = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
            var regM = /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if (regP.test(this.ruleForm.photo)) {
              queryStr.mobile = this.ruleForm.photo;
              queryStr.mail = "";
            } else {
              queryStr.mobile = "";
              queryStr.mail = this.ruleForm.photo;
            }
            console.log(queryStr);
              BaseApi.createRpcToken("/signatory/queryUserName", queryStr)
          .then(
            data => {
              if(data.datas.resultList){

              let resultList = data.datas.resultList;
              this.queryuserNameList=resultList
              console.log(resultList)
              if (resultList[0].id) {
                console.log(resultList[0].id)
                if (this.judgeUid(resultList[0].id)) {
                  
                } else {
                  this.$message.error("不能添加相同的签署方");
                }
              } else {
                resultList[0].name && (queryStr.name = resultList[0].name);
                resultList[0].type && (queryStr.type = resultList[0].type);
                resultList[0].signUserId &&
                  (queryStr.signUserId = resultList[0].signUserId);
                this.powerId && (queryStr.userId = this.powerId);
                BaseApi.createRpcToken(
                  "/signatory/addSignatory",
                  queryStr,
                  "post"
                )
                  .then(
                    data => {
                  if (data.datas.hasOwnProperty("message") == false) {
                    this.dialogVisible = false;
                    this.isSubmit = true;
                    this.init();
                  } else {
                    this.$message.error("用户已经存在,不能重复添加");
                    this.isSubmit = true;
                  }
                    },
                    () => {}
                  )
                  .catch(function(e) {
                    errorLog(e);
                  });
              }
             }else{
               
             }
            },
            error => {
              console.log(error);
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
          } else {
            if (localStorage.getItem("userName") == this.ruleForm.photoEn) {
              this.$message.error("不能添加自己为授权人");
              return;
            }
            var queryStr = {
              name: this.ruleForm.photoEn,
              mobile: "",
              mail: "",
              type: "2"
            };
            // var regP = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
            // var regM = /^[A-Za-z0-9_-\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            // if (regP.test(this.ruleForm2.photoPer)) {
            //   queryStr.mobile = this.ruleForm2.photoPer;
            //   queryStr.mail = "";
            // } else {
            //   queryStr.mobile = "";
            //   queryStr.mail = this.ruleForm2.photoPer;
            // }
             BaseApi.createRpcToken("/signatory/enterpriseRealNameValidate", { name:  this.ruleForm.photoEn })
              .then(
                data => {
                  if(data.datas.success){
                        console.log(queryStr,"添加企业");
                        BaseApi.createRpcToken("/signatory/v2/addEnterpriseSignatory", queryStr, "post")
                          .then(
                            data => {
                              if(data.datas.code==3001){
                              this.$message.error(data.datas.message);
                            }else if(!data.datas.code){
                              if (data.success) {
                                let queryParams = {
                                    mail: "",
                                    mobile: "",
                                    handleType: "1",
                                    partnerId: data.datas.signatoryId
                                  };
                                  this.init()
                                  this.dialogVisibleEn=false;
                                  this.ruleForm.photoEn=""
                                  this.isSubmit = true;
                              } else {
                                this.$message.error("不能添加相同的签署方");
                                this.isSubmit = true;
                              }
                            }
                            },
                            data => {}
                          )
                          .catch(function(e) {
                            errorLog(e);
                          });
                  }else{
                    this.$message.error("请输入已实名企业");
                  }
                },
                err => {}
              )
              .catch(function(e) {
                errorLog(e);
              });
          
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSizeChangep(val) {
      this.pageSizep = val;
      this.init();
    },
    handleCurrentChangep(val) {
      this.currentPagep = val;
      this.init();
    }
  },
  components: {
    Dialog,
    breadcrumb
  },
  created() {
    this.init();
  },
  watch:{
    "getUserInfo.currentUserId"(data){
      this.init()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signatoryList {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  .signatoryBox {
    width: 100%;
    height: 100%;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
    .authorizationMain {
      width: 100%;
      margin-top: 30px;
      .authorizationTab {
        width: 100%;
        overflow: hidden;
        ul {
          li {
            float: left;
            border: 1px solid #e4e8eb;
            height: 36px;
            line-height: 36px;
            width: 120px;
            background: #f5f5f5;
            border-bottom: none;
          }
          li:nth-child(2) {
            border-left: 0;
          }
          .authorActive {
            border-top: 2px solid #db4437;
            height: 35px;
            line-height: 35px;
            background: #fff;
          }
          .seekBox {
            width: 228px;
          }
          .addAuthorizer {
            float: right;
            display: block;
            width: 100px;
            height: 36px;
            line-height: 36px;
            border: 1px solid #e29999;
            color: #e29999;
            margin: 0;
          }
          .addAuthorizer:hover {
            background: #db4437;
            color: #fff;
          }
          .searchBtn {
            display: block;
            width: 30px;
            height: 30px;
            background: url("../../../assets/images/warning/search_icon_nor.png");
          }
          .searchBtn:hover {
            background: url("../../../assets/images/warning/search_icon_pre.png");
          }
        }
      }
      .authorizationCon {
        width: 100%;
        padding-bottom: 20px;
        display: table;
        box-sizing: border-box;
        .authorTable {
          .el-pagination {
            padding: 0;
            float: right;
          }
          table {
            table-layout: auto;
            th {
              background: #f9f9f9;
            }
            tr {
              height: 32px;
              th {
                text-align: center;
                white-space: nowrap;
              }
              td {
                text-align: center;
                padding: 0;
                height: 32px;
              }
            }
            thead {
              width: 100%;
              background: #f9f9f9;
              color: #505050;
              input {
                vertical-align: middle;
                width: 12px;
                height: 12px;
              }
            }
            tbody {
              tr {
                color: #969696;
                height: 48px;
                input {
                  width: 12px;
                  height: 12px;
                }
              }
            }
          }
          .fenYeBox {
            margin-top: 20px;
          }
          .authorizationTrigger {
            margin-top: 22px;
            height: 32px;
            line-height: 32px;
            div {
              input[type="checkbox"] {
                width: 12px;
                height: 12px;
                border: 1px solid #db4437;
                margin: 0 22px;
                vertical-align: middle;
              }
              .authorTion {
                display: inline-block;
                width: 100px;
                height: 30px;
                border: 1px solid #db4437;
                color: #db4437;
              }
              .authorTion:hover {
                background-color: #db4437;
                color: #fff;
              }
            }
          }
        }
        .allAuthorized {
          .authorSearch {
            width: 100%;
            display: table;
            margin-bottom: 8px;
            input {
              width: 300px;
              height: 30px;
              border: 1px solid #e4e8eb;
              text-indent: 10px;
              font-size: 14px;
            }
            span:nth-child(2) {
              display: block;
              float: left;
              margin-left: 10px;
              width: 30px;
              height: 30px;
              background-size: cover;
              cursor: pointer;
              background: url("../../../assets/images/warning/search_icon_nor.png");
            }
            span:nth-child(2):hover {
              background: url("../../../assets/images/warning/search_icon_pre.png");
              background-size: cover;
            }
            span:last-child {
              display: flex;
              width: 180px;
              align-items:center;
              height: 45px;
              line-height: 32px;
              color: #e29999;
              cursor: pointer;
              border: 1px dashed #db4437;
              color: #db4437;
              background-color: #fcfcfc;
              justify-content:center;
              font-size: 14px;
              i{
                display:inline-block;
                width:20px;
                height:20px;
                background: url("../../../assets/images/personalSign/Shape.png");
                background-size:cover;
                margin-right:20px;
              }
            }
            span:last-child:hover {
              background-color:  rgb(248,248,248);
            }
            .enter{
              display: flex;
              width: 180px;
              align-items:center;
              height: 45px;
              line-height: 32px;
              color: #e29999;
              cursor: pointer;
              border: 1px dashed #db4437;
              color: #db4437;
              background-color: #fcfcfc;
              justify-content:center;
              font-size: 14px;
              margin-left:20px;
              i{
                display:inline-block;
                width:20px;
                height:20px;
                background: url("../../../assets/images/personalSign/Shape.png");
                background-size:cover;
                margin-right:20px;
              }
            }
             .enter:hover {
              background-color: rgb(248,248,248);
            }
          }
          th {
            padding: 0 10px;
            word-wrap: break-word;
          }
          th:nth-child(1),
          td:nth-child(1) {
            width: 35%;
          }
          th:nth-child(2),
          td:nth-child(2) {
            width: 35%;
          }
          th:nth-child(3),
          td:nth-child(3) {
            width: 10%;
          }
          th:nth-child(4),
          td:nth-child(4) {
            width: 10%;
          }
          th:nth-child(5),
          td:nth-child(5) {
            width: 10%;
          }
          .cell {
            line-height: 30px;
            span {
              img {
                vertical-align: middle;
                margin-right: 3px;
              }
            }
          }
        }
        .contractAuthorized {
          .authorSearch {
            width: 100%;
            display: table;
            margin-bottom: 8px;
            input {
              width: 300px;
              height: 30px;
              border: 1px solid #e4e8eb;
              text-indent: 10px;
              font-size: 14px;
            }
            span:nth-child(2) {
              display: block;
              float: left;
              margin-left: 10px;
              width: 30px;
              height: 30px;
              background-size: cover;
              background: url("../../../assets/images/warning/search_icon_nor.png");
            }
            span:nth-child(2):hover {
              background: url("../../../assets/images/warning/search_icon_pre.png");
              background-size: cover;
            }
            span:last-child {
              display: block;
              width: 100px;
              height: 32px;
              line-height: 32px;
              border: 1px solid #e29999;
              color: #e29999;
            }
            span:last-child:hover {
              background-color: #a5303d;
              color: #fff;
            }
          }
          th {
            padding: 0;
          }
          th:nth-child(1),
          td:nth-child(1) {
            width: 35%;
          }
          th:nth-child(2),
          td:nth-child(2) {
            width: 35%;
          }
          th:nth-child(3),
          td:nth-child(3) {
            width: 10%;
          }
          th:nth-child(4),
          td:nth-child(4) {
            width: 10%;
          }
          th:nth-child(5),
          td:nth-child(5) {
            width: 10%;
          }
          .cell {
            line-height: 30px;
            span {
              img {
                vertical-align: middle;
                margin-right: 3px;
              }
            }
          }
        }
      }
    }
  }
  .popUp {
    .el-dialog {
      display: table;
      background: #f5f5f5;
      .header {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        .el-icon-close {
          top: 15px;
        }
      }
      .enBox{
         height: 180px !important;
         .addSignatoryCon{
            overflow: visible !important;
         }
      }
      .addSignatoryBox {
        width: 100%;
        height: 150px;
        padding: 30px 0;
        box-sizing: border-box;
        background-color: #fff;
        .addSignatoryCon {
          width: 301px;
          margin: 0 auto;
          text-align: left;
          overflow: hidden;
          .el-form {
            .el-form-item__label {
              padding: 0;
              line-height: 30px;
            }
            .el-form-item__content {
              line-height: 30px;
              width: 200px;
              color: #919191;
              text-align: center;
              .el-input__inner {
                height: 30px;
                line-height: 30px;
                border-radius: 0;
                padding: 0;
                text-indent: 10px;
              }
              .el-button {
                width: 100px;
                height: 32px;
                line-height: 32px;
                border: 1px solid #db4437;
                color: #db4437;
                padding: 0;
                border-radius: 0;
                background-color: #fff;
                // position: absolute;
                // left: 150px;
              }
              .el-button--primary {
                color: #fff;
                background: #D81212;
                margin-left: 20px;
              }
              .el-input__icon {
                line-height: 30px;
              }
            }
            .el-form-item:last-child {
              margin-top: 25px;
              height: 35px;
              margin-bottom: 0;
              .el-form-item__content {
                width: 100%;
                margin-left: 0 !important;
                margin-left: 10px;
                .el-button:hover {
                  background: #D81212;
                  color: #fff;
                }
              }
            }
          }
          .el-form-item:nth-child(2) {
            .el-form-item__content {
              position: relative;
              .hintBox {
                position: absolute;
                left: 0;
                top: 27px;
                font-size: 12px;
                color: #f56c6c;
              }
            }
          }
        }
      }
      .changeStatus {
        height: 200px;
        p:nth-child(1) {
          width: 100%;
          height: 140px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      p:last-child {
        text-align: center;
        span {
          display: inline-block;
          width: 100px;
          height: 32px;
          line-height: 32px;
          border: 1px solid #D81212;
          color: #db4437;
          cursor: pointer;
        }
        span:last-child {
          margin-left: 20px;
          color: #fff;
          background-color: #D81212;
        }
      }
    }
  }
  .enSign{
    .el-form-item__content{
      margin-left:0px !important;
      margin-top:10px;
      .el-input {
        width:300px;
        font-size:12px;
      }
    }
  }
}
</style>
